<template>
    <toolbar-option>
        <template slot="primary">
            <toggle
                :value="isChecked"
                :messages="messages"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'tabbed-nav-transition';

export default {
    name: 'advanced-tabbed-nav-transition',
    mixins: [baseOption],

    data() {
        return {
            isChecked: true,
            displayName: 'Advanced Tabbed Nav Transition in Mobile',
            messages: {
                checked: 'Has Transition',
                unchecked: 'Has No Transition',
            },
        };
    },

    methods: {
        onInput(isChecked) {
            this.isChecked = isChecked;
            const value = this.isChecked;
            this.setData(value);
        },
        setData(value) {
            this.selectedElements.forEach((elem) => {
                elem.setElementData(CUSTOM_ATTR_NAME, value);
            });
        },
        onSelectedElement() {
            const value = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);
            this.isChecked = value;
        },
    },
};
</script>
